<div class="row">
  <div class="col">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
      </ol>
    </nav>
  </div>
</div>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3">
  <h1 class="h2">Dashboard</h1>
</div>
<div class="card mb-3" *ngIf="this.accountInfo?.isAdmin">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h4>Status by Rep</h4>
        <h6>Date Range</h6>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <form [formGroup]="dateForm" (ngSubmit)="dateFormOnSubmit()">
          <div class="row">
            <div class="col-sm-3 col-lg-2 col-xl-2 col-xxl-1">
              <div class="form-group my-1">
                <label for="month" class="sr-only">Month</label>
                <select id="month" class="form-control" formControlName="month">
                  <option *ngFor="let month of months" [value]="month.id">{{ month.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-3 col-lg-2 col-xl-2 col-xxl-1">
              <div class="form-group my-1">
                <label for="year" class="sr-only">Year</label>
                <select id="year" class="form-control" formControlName="year">
                  <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-3 col-lg-1 d-flex align-items-end">
              <button type="submit" class="btn btn-primary my-1" [disabled]="dateForm.invalid">Search</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <app-status-by-rep-grid></app-status-by-rep-grid>
    </div>
  </div>
</div>
<div class="card mb-3">
  <div class="card-body">
    <div class="row">
      <h4>Surveys Needing Approval</h4>
      <app-surveys-needing-approval-grid></app-surveys-needing-approval-grid>
    </div>
  </div>
</div>
